const getGoogleClientId = () => {
  const tracker = window?.ga?.getAll?.()?.[0];
  return tracker?.get('clientId');
};

export default getGoogleClientId;
